function isTrainingSubTab() {
  return !!~window.location.href.indexOf('/training')
}

export default isTrainingSubTab
